import React from 'react';
import { InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TikTokIcon } from './icons/TikTokIcon';
export function Footer() {
  return <footer className="w-full bg-neutral-900 px-4 pb-3 pt-5 text-neutral-300 sm:px-6" data-id="element-223" data-mp="32o4d0g3lai96">
      <div className="mx-auto flex max-w-[1300px] flex-col gap-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-224" data-mp="36pfu1x8edv5r">
        <div className="flex items-center justify-center gap-3 sm:flex-1 sm:justify-start" data-id="element-225" data-mp="3ueijvsd6qubc">
          <img src="https://cdn.magicpatterns.com/uploads/tNLTDY1fCXiQ1zp6ggV3Ei/hot-sales-girls-academy-logo.webp" alt="Hot Sales Girls Academy Logo" loading="lazy" decoding="async" className="h-10 w-10 rounded-full object-contain" data-id="element-226" data-mp="38h2z36jh6hs" />
          <span className="text-sm font-semibold uppercase tracking-widest text-white" data-id="element-227" data-mp="29ynmxp3fzdg4">
            Hot Sales Girls<sup className="ml-0.5 text-[1.45em] leading-none" style={{
            verticalAlign: 'baseline',
            position: 'relative',
            top: '-0.06em'
          }} data-id="element-228" data-mp="2eyt7ymf7i1p8">
              ®
            </sup>
          </span>
        </div>

        <nav aria-label="Footer" className="grid shrink-0 grid-cols-2 gap-x-6 gap-y-2 text-center text-sm lg:flex lg:items-center lg:gap-8" data-id="element-229" data-mp="3gca6z6kkzzcs">
          <Link to="/ablauf-der-hot-sales-girls-academy" className="hover:text-white" data-id="element-230" data-mp="3q7ln9tbn1emn">
            Ablauf der Academy
          </Link>
          <Link to="/ueber-tina-xla" className="hover:text-white" data-id="element-231" data-mp="8178js5jp0n7">
            Über Tina
          </Link>
          <Link to="/impressum" className="hover:text-white" data-id="element-232" data-mp="31uotg9z09ou">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-white" data-id="element-233" data-mp="huwlv6wb8jb1">
            Datenschutz
          </Link>
        </nav>

        <div className="flex items-center justify-center gap-3 sm:flex-1 sm:justify-end" data-id="element-234" data-mp="qti0iqynve6j">
          <a href="https://www.instagram.com/tina_xla/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-235" data-mp="mrwp7a1rz7yg">
            <InstagramIcon className="h-5 w-5" aria-hidden="true" data-id="element-236" data-mp="yrv4arsve3rh" />
          </a>
          <a href="https://www.tiktok.com/@tina_xla?_t=ZN-8tHLLH6ugD8&_r=1" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-237" data-mp="13r7mv0cpkoo9">
            <TikTokIcon className="h-5 w-5" data-id="element-238" data-mp="1hmifs87e6zpz" />
          </a>
          <a href="https://www.youtube.com/@tina_xla" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-800 hover:bg-neutral-700" data-id="element-239" data-mp="1ml3eu4awrdcu">
            <YoutubeIcon className="h-5 w-5" aria-hidden="true" data-id="element-240" data-mp="3tb17htaxycgg" />
          </a>

        </div>
      </div>

      <p className="mx-auto mt-3 max-w-[1300px] text-center text-xs text-neutral-500" data-id="element-241" data-mp="2afwz4q22lr18">
        © 2026 Mermaid Beauty Aesthetics FZCO. Alle Rechte vorbehalten.
      </p>
    </footer>;
}